/* =========================================================
   CLASS CHAMPIONS — Theme JavaScript (every page)
   Desktop header dropdowns and scroll reveal (blog).
   Phone menu: assets/cc-mobile-nav.js. Home page: assets/cc-home.js.
   Cart: assets/cc-cart.js.
   ========================================================= */

document.addEventListener("DOMContentLoaded", () => {

  /* ---------- v1.16 Header dropdowns (desktop) ----------
     Open/close is the native <details> element (click, tap, Enter, Space).
     This only closes them: on a click outside, on Escape, and when another one opens. */
  const navDropdowns = Array.from(document.querySelectorAll(".nav [data-nav-dd]"));
  if (navDropdowns.length) {
    navDropdowns.forEach((dd) => {
      dd.addEventListener("toggle", () => {
        if (dd.open) navDropdowns.forEach((other) => { if (other !== dd) other.open = false; });
      });
    });
    document.addEventListener("click", (e) => {
      navDropdowns.forEach((dd) => { if (dd.open && !dd.contains(e.target)) dd.open = false; });
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      const openDd = navDropdowns.find((dd) => dd.open);
      if (!openDd) return;
      openDd.open = false;
      openDd.querySelector("summary").focus();
    });
  }

  /* ---------- Reveal on Scroll ---------- */
  // Off in the theme editor (re-rendered sections are never observed) and for reduced-motion visitors.
  const revealEls = document.querySelectorAll(".reveal");
  const revealOff = (window.Shopify && window.Shopify.designMode) || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!revealOff && "IntersectionObserver" in window && revealEls.length) {
    document.body.classList.add("has-reveal");
    const io = new IntersectionObserver((entries) => {
      let batch = 0;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Items entering together (e.g. a row of cards) are staggered 80ms apart, capped at 400ms.
          entry.target.style.setProperty("--reveal-delay", Math.min(batch++, 5) * 80 + "ms");
          entry.target.classList.add("visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -50px 0px" });
    revealEls.forEach(el => io.observe(el));
    // Reveal once per page: when the animation ends (or is cut short by a hidden tab), lock the final
    // state so re-showing a hidden element (e.g. switching tabs) never restarts it.
    const lockReveal = (e) => {
      if (e.animationName === "ccReveal") e.target.classList.add("reveal--instant");
    };
    document.addEventListener("animationend", lockReveal);
    document.addEventListener("animationcancel", lockReveal);
    requestAnimationFrame(() => {
      revealEls.forEach(el => {
        const r = el.getBoundingClientRect();
        // Already on screen at load: show without animating, so nothing already painted flickers.
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("visible", "reveal--instant");
      });
    });
  }

});
